<template>
    <el-dialog
            :visible="Boolean(value)"
            :direction="direction"
            class="draw_advanced-search"
            :append-to-body="true"
            :modal="true"
            :modal-append-to-body="false"
            :wrapperClosable="true"
            :show-close="false"
            :before-close="clickBackSearch">
        <div class="pd-advanced-search">
            <div class="selectBtn">
                <el-button round
                           v-model="selectedData"
                           @click="selectDoc(table.key)"
                           v-for="table in docList"
                           :key="table.key"
                           :type="(selectedData===table.key)?'warning':'text'"
                           plain
                           size="mini"
                           class="bigFirst"
                           :label="table.key">{{table.value}}
                </el-button>
            </div>
            <!--        <div class="listAll">-->
            <!--          <el-scrollbar style="height:100%">-->
            <ul class="son">
                <li class="pd-search-item" v-for="(tool, index) in searchSettings" :key="index"
                    v-if="tool.column !=='published'">
                    <!--          条件并且或者-->
                    <div v-if="index === 1" style="width: 79px"></div>
                    <!--                    <el-select v-if="index === 1" v-model="firstAnd" placeholder="no" disabled size='small'></el-select>-->
                    <el-select class="and-condition" v-if="index!== 1" size='small' v-model="tool.midd"
                               placeholder="please select">
                        <el-option
                                v-for="item in middOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <!--          <span class="middle-text">在</span>-->
                    <!--          条件类型-->
                    <el-select v-model="tool.column" clearable placeholder="please select"
                               @change="(value)=>chagneColumn(value,tool)"
                               size='small'>
                        <el-option
                                v-for="item in keyOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <!--          <span class="middle-text">中</span>-->
                    <!--          精确或者模糊-->
                    <el-select v-model="tool.type" placeholder="please select" size='small'>
                        <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <!--          <span class="middle-text">匹配</span>-->
                    <!--          匹配结果-->
                    <el-input v-model="tool.value" :maxlength="createdMaxLength(tool.column)" class="lastInput"
                              placeholder="Please enter key words..."
                              size='small'></el-input>
                    <i v-if="index === 1" @click="addSearchSettings" class="el-icon-circle-plus"></i>
                    <i v-else @click="reduceSearchSettings(index)" class="el-icon-remove"></i>
                </li>
            </ul>
            <div class="time-date">
                <p>Publish time</p>
                <el-date-picker
                        size='small'
                        v-model="searchSettings[0].value"
                        type="daterange"
                        align="left"
                        class="data-picker bigFirst"
                        value-format="yyyy-MM-dd"
                        unlink-panels
                        range-separator="and"
                        start-placeholder="Start time"
                        end-placeholder="End time">
                </el-date-picker>
            </div>
            <!--          </el-scrollbar>-->
            <!--        </div>-->
            <div>
                <el-button type="primary" @click="clickSearchBySettings" size="small">Search</el-button>
                <el-button @click="clearSearch" size="small">Empty</el-button>

            </div>
        </div>
    </el-dialog>
</template>

<script>
import * as _ from 'lodash'
import searchMap from './utils/searchMap'

export default {
  name: 'advanceSearch',
  props: {
    tableList: {
      type: Array
    },
    domParameter: {
      type: Object
    },
    value: {
      type: Number
    }
  },
  data () {
    return {
      // drawer: false,
      firstAnd: 'no',
      keyOptions: [],
      direction: 'ttb',
      selectedData: 'All', // id和data相互绑定
      selectId: 'All',
      searchSettings: [
        {
          column: 'published',
          type: 0, // 类型：0：精确 1：模糊
          value: '', // 值
          midd: 0 // 0：并且  1：或者 2：不含
        },
        {
          column: '',
          type: 1, // 类型：0：精确 1：模糊
          value: '', // 值
          midd: 0 // 0：并且  1：或者 2：不含
        }
      ],
      middOptions: [
        {
          label: 'and',
          value: 0
        },
        {
          label: 'or',
          value: 1
        },
        {
          label: 'BPA',
          value: 2
        }
      ],
      typeOptions: [
        {
          label: 'exact',
          value: 0
        },
        {
          label: 'vague',
          value: 1
        }
      ],
      typeTimeOptions: [
        {
          label: 'between',
          value: 0
        }
      ],
      style: null
    }
  },
  watch: {
    'tableList': {
      handler (newVal) {
        newVal.length && this.selectTable()
      },
      deep: true
    },
    'value': {
      handler (newVal) {
        if (Boolean(newVal)) {
          this.$nextTick(() => {
            if (sessionStorage.getItem('enAdSearch')) {
              const data = JSON.parse(sessionStorage.getItem('enAdSearch'))
              const list = data.list
              this.selectedData = data.selectedData
              this.selectId = data.selectId
              this.selectTable(this.selectedData)
              setTimeout(() => {
                this.searchSettings = list
              })
            }
          })
        }
      },
      immediate: true
    },
    'domParameter': {
      handler (newVal) {
        if (newVal) {
          const style = {
            'margin-left': `${newVal.left}px`,
            'width': `${newVal.width < 550 ? 550 : newVal}px`
          }
          const dom = document.querySelector('.draw_advanced-search').children[0]
          for (let key in style) {
            dom.style[key] = style[key]
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    docList () { // radio组
      // const arr = _.filter(searchMap.typeAgg, (item) => {
      //   return item.key !== 'video'
      // })
      // return this.sortArr(arr)
      return [{
        key: 'All',
        id: 'All',
        // id: '102',
        value: 'All'
      }, {
        key: 'Real-time Info',
        id: 'Real-time Info',
        // id: '102',
        value: 'Real-time Info'
      },
        {
          key: 'Report',
          id: 'Report',
          value: 'Report'
        },
        {
          key: 'Video',
          id: 'Video',
          value: 'Video'
        }
      ]
    }
  },
  mounted () {
    $('.v-modal').on('click', () => {
      this.value = 0
      this.clickBackSearch()
    })
  },
  methods: {
    // sortArr (searchArr) {
    //   const arr = ['动态', '观点', '研报', '咨询', '案例', '论文']
    //   const _searchArr = []
    //   _.forEach(arr, (name) => {
    //     const item = _.find(searchArr, ['value', name])
    //     item && _searchArr.push(item)
    //   })
    //   return _searchArr
    // },
    createdMaxLength (type) {
      const i = ['key_words.keyword', 'one_level_state.keyword']
      if (i.indexOf(type) > -1) {
        return 20
      } else {
        return 200
      }
    },
    addSearchSettings () {
      if (this.searchSettings.length < 10) {
        this.searchSettings.push({
          column: '',
          type: 1, // 类型：0：精确 1：模糊
          // iscore: '',	// 0：不分词 1：分词
          value: '', // 值
          midd: 0 // 0：并且  1：或者 2：不含
        })
      } else {
        this.$message.error('More than 9 entries cannot be added')
      }
    },
    reduceSearchSettings (index) {
      this.searchSettings.splice(index, 1)
    },
    clickSearchBySettings () {
      let lock = false
      const setting = _.filter(this.searchSettings, (item) => {
        if (item.column === 'published' || (!item.column && !item.value && item.value !== 0)) {
          return false
        }
        return true
      })
      _.forEach(setting, (item) => {
        if ((!item.column && item.column !== 0) || (!item.value && item.value !== 0)) {
          lock = true
          return false
        }
      })
      if (lock) {
        this.$message.error('Please complete the search conditions')
        return false
      }
      this.$emit('searchAdvance', {
        hightQueryBean: this.searchSettings,
        type: this.selectedData,
        selectId: this.selectId
      })
      this.clearSearch()
    },
    clearSearch () {
      sessionStorage.setItem('enAdSearch', JSON.stringify({
        selectId: this.selectId,
        selectedData: this.selectedData,
        list: this.searchSettings
      }))
      this.searchSettings = [
        {
          column: 'published',
          type: 0,
          value: '',
          midd: 0
        }, {
          column: '',
          type: 1,
          value: '',
          midd: 0
        }
      ]
    },
    clickBackSearch (done) {
      this.clearSearch()
      this.$emit('searchAdvance', {}, false)
      this.$emit('input', 0)
      done && done()
    },
    selectDoc (value) {
      this.selectedData = value
      this.selectId = _.find(this.docList, (item) => {
        return item.key === value
      }).id
      this.selectTable(value)
      // this.searchSettings = [
      //   {
      //     column: 'published',
      //     type: 0,
      //     value: '',
      //     midd: 0
      //   }, {
      //     column: '',
      //     type: 1,
      //     value: '',
      //     midd: 0
      //   }
      // ]
      this.searchSettings = _.map(this.searchSettings, (item) => {
        if (item.column !== 'published') {
          item.column = ''
        }
        return item
      })
      // }
    },
    selectTable (value) {
      // const table = _.find(this.tableList, {lab: 'All'})
      const table = _.find(this.tableList, {lab: this.selectId})
      let arr = []
      if (table && table.config) {
        _.forEach(table.config.mapping, (item) => {
          if (item.name.indexOf('_') === -1 && item['is_advanced_search']) {
            const ite = {
              label: item.name,
              value: item.column_item[0]
            }
            arr.push(ite)
          }
        })
      }
      this.keyOptions = arr
    },
    chagneColumn (value, item) {
    }
  },
  created () {
    this.selectTable()
  }
}
</script>
<style lang="less" scoped>
    .draw_advanced-search {
        /deep/ .el-dialog {

            width: calc(40% * 0.98 - 90px);
            margin-top: 67px !important;

            .el-dialog__header {
                display: none;
            }

            .el-dialog__body {
                padding: 10px 5px;
            }
        }
    }

    span:focus {
        outline: transparent !important;
    }

    .selectBtn {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 0 0 10px;

    }

    button:focus {
        outline: none;
    }

    .el-button--warning.is-plain:focus, .el-button--warning.is-plain:hover {
        background: #fdf6ec;
        border-color: #E6A23C;
        color: #E6A23C;
    }

    .pd-advanced-search {
        width: 100%;
        text-align: center;

        .advanced-search-title {
            border-bottom: 1px solid #606266;
            padding-bottom: 10px;
            text-align: left;
            color: white;
        }

        /deep/ .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        .listAll {
            height: 80px;
        }

        ul {
            list-style: none;
            padding: 0 10px;
            margin-top: 5px;
            margin-bottom: 1rem !important;
            width: 100%;

            .pd-search-item {
                padding: 8px 8px 8px 0;
                display: flex;
                align-items: center;

                .lastInput {
                    width: 115px;
                }

                > div:not(:first-child) {
                    margin: 0 0 0 15px;
                }

                > div:first-child, div:nth-child(3) {
                    width: 79px;
                }

                /deep/ .el-select {
                    flex-shrink: 0;

                    .el-input__inner {
                        padding-right: 23px;
                    }

                    .el-input__suffix {
                        right: 0;
                    }
                }

                .el-date-editor, .lastInput {
                    flex-grow: 1;
                }

                .and-condition {
                }

                .middle-text {
                    display: inline-block;
                    width: 50px;
                }

                i {
                    margin-left: 10px;

                    &:hover {
                        cursor: pointer;
                    }
                }

                .el-icon-circle-plus {
                    font-size: 16px;
                    color: #67C23A;
                }

                .el-icon-remove {
                    font-size: 16px;
                    color: #F56C6C;
                }

                .el-select {
                    width: 120px;
                }
            }
        }

        .time-date {
            display: flex;
            align-items: center;
            margin: -0.5rem 0 1rem 0;

            p {
                margin: 0 27px 0 10px;
            }
        }
    }

    .data-picker {
        padding: 3px 0 !important;

        /deep/ .el-icon-date {
            margin-left: 3px;
        }

        /deep/ .el-range-separator {
            width: 24px !important;
        }

        /deep/ .el-range__close-icon {
            margin: 0 2px !important;
        }

        /deep/ .el-range-separator {
            width: 37px !important;
            padding: 0 !important;
        }
    }

    @media screen and(max-width: 1300px) {
        .el-drawer__wrapper {
            right: auto !important;
            left: auto !important;
            transform: translateX(-16%);
        }
    }

    .bigFirst {
        text-transform: capitalize;
    }

    .pd-search-item {
        /deep/ .el-select {
            .el-input__inner {
                text-transform: capitalize;
            }
        }
    }
</style>
<style lang="less">
    .el-select-dropdown {
        .el-select-dropdown__item {
            text-transform: capitalize;
        }
    }
</style>
